var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Toile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24.009766 5 A 1.50015 1.50015 0 0 0 22.658203 5.8300781 L 17.505859 16.134766 L 5.2714844 18.017578 A 1.50015 1.50015 0 0 0 4.4394531 20.560547 L 12.902344 29.023438 L 11.017578 41.271484 A 1.50015 1.50015 0 0 0 13.193359 42.830078 L 24 37.191406 L 34.806641 42.830078 A 1.50015 1.50015 0 0 0 36.982422 41.271484 L 35.097656 29.023438 L 43.560547 20.560547 A 1.50015 1.50015 0 0 0 42.728516 18.017578 L 30.494141 16.134766 L 25.341797 5.8300781 A 1.50015 1.50015 0 0 0 24.009766 5 z M 24 9.8535156 L 28.158203 18.169922 A 1.50015 1.50015 0 0 0 29.271484 18.982422 L 39.345703 20.533203 L 32.439453 27.439453 A 1.50015 1.50015 0 0 0 32.017578 28.728516 L 33.566406 38.798828 L 24.693359 34.169922 A 1.50015 1.50015 0 0 0 23.306641 34.169922 L 14.433594 38.798828 L 15.982422 28.728516 A 1.50015 1.50015 0 0 0 15.560547 27.439453 L 8.6542969 20.533203 L 18.728516 18.982422 A 1.50015 1.50015 0 0 0 19.841797 18.169922 L 24 9.8535156 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Toile);
export default __webpack_public_path__ + "static/media/icons8-étoile.a0fe15412afba68231adb28bfcc93083.svg";
export { ForwardRef as ReactComponent };